import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import logo from "../images/logo.png";
import { useLocation } from "react-router-dom";
import { api_url } from "../config/config";  
 
const AdminSideBar = ({ activeItem, handleNavigation }) => {
  const navigate = useNavigate();
  const location = useLocation();
 
  const [access, setAccess] = useState("admin");
  const token = localStorage.getItem("admin_token");
  const role = localStorage.getItem("roles");
  const [ordersCount, setOrdersCount] = useState(0);
  const [prescriptionCount, setPrescriptionCount] = useState(0);
  const [userPermissions, setUserPermissions] = useState(null);
 
  const handleItemClick = (item, route) => {
    handleNavigation(item);
 
    // Routes mapping
    const routes = {
      Profile: "/ng-admin",
      Products: "/ng-admin/product-list",
      PrescriptionList: "/ng-admin/prescription-list",
      Customers: "/ng-admin/customers",
      Vendors: "/ng-admin/vendors",
      Category: "/ng-admin/cat",
      SubCategory: "/ng-admin/subcat",
      AdminAction: "/ng-admin/admin-action",
      AddOn: "/ng-admin/addon",
      VendorAction: "/ng-admin/vendor-action",
      Orders: "/ng-admin/orders",
      Blogspage: "/ng-admin/blogs",
      BlogType: "/ng-admin/blog-types"
    };
 
    if (item === "Logout") {
      handleLogout();
    } else {
      navigate(route || routes[item] || `/ng-admin/${item.toLowerCase()}`);
    }
  };
 
  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("roles");
    navigate("/ng-admin/login");
  };
 
  const allLinks = [
    { label: "Profile", route: "/ng-admin" },
    { label: "Products", route: "/ng-admin/product-list" },
    { label: "Prescription List", route: "/ng-admin/prescription-list" },
    { label: "Orders", route: "/ng-admin/orders" },
    { label: "Employee", route: "/ng-admin/employee" },
    { key: "Access Control", label: "Access Control", route: "/ng-admin/access-control" },
    { label: "Category", route: "/ng-admin/cat" },
    { label: "Concern", route: "/ng-admin/concern" },
    { label: "Manufacturer", route: "/ng-admin/manufacturer" },
    { label: "Content Update", route: "/ng-admin/addon" },
    { label: "Admin Action", route: "/ng-admin/admin-action" },
    { label: "Employee Action", route: "/ng-admin/vendor-action" },
    { label: "Blogs", route: "/ng-admin/blogs" },
    { label: "Blogs Type", route: "/ng-admin/blog-types" },
    { label: "Manage Stores", route: "/ng-admin/branches" },
    { label: "Payments", route: "/ng-admin/payments" },
    { label: "Customer Queries", route: "/ng-admin/customer-queries" },
    { label: "Order Transfer History", route: "/ng-admin/order-transfer-history" },
  ];
 
  const permissionMaping = {
    "Profile": "Profile",
    "Admin Action": "AdminAction",
    "Access Control": "AccessControl",
    "Employee": "Employee",
    "Employee Action": "EmployeeAction",
    "Products": "Products",
    "Prescription List": "Prescriptions",
    "Orders": "Orders",
    "Category": "Category",
    "Concern": "Concern",
    "Manufacturer": "Manufacturer",
    "Content Update": "ContentUpdate",
    "Blogs": "Blogs",
    "Blogs Type": "BlogsType",
    "Manage Stores": "ManageStores",
    "Payments": "Payments",
    "Customer Queries": "CustomerQueries",
    "Order Transfer History": "OrderTransferHistory",
  };
 
  const fetchProfileData = async () => {
    try {
      const response = await fetch(`${api_url}/admin/profile-user`, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        },
      });
      const json = await response.json();
      const data = json?.data || json;
      const perms = data?.permissions || {};
      setUserPermissions(perms);
    } catch (e) {
      console.error(e);
      setUserPermissions({});
    }
  };
 
  useEffect(() => {
    fetchProfileData();
  }, []);
 
  const sidebarLinks = useMemo(() => {
    return allLinks.filter((link) => {
      const key = permissionMaping[link.label];
      if (!key) return false; 
      if (!userPermissions) return false;
      return Boolean(userPermissions[key]);
    });
  }, [allLinks, userPermissions]);
 
  useEffect(() => {
    setAccess(role); // Set access role based on stored role
  }, [role]);
    const getOrdersCount = async() => {
      try{
        const response = await fetch(`${api_url}/orders-count`, {
          method: 'GET',
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          },
        })
        const { data } = await response.json();
        setOrdersCount(data);
      }catch(e){
        console.log(e);
      }
    }
 
    const getPrescriptionCount = async() => {
      try{
        const response = await fetch(`${api_url}/prescription-count`, {
          method: 'GET',
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          },
        })
        const { data } = await response.json();
        setPrescriptionCount(data);
      }catch(e){
        console.log(e);
      }
    }
    useEffect(() => {
      getOrdersCount();
      getPrescriptionCount();
    }, []);
  return (
    <div className="h-screen w-48 bg-[#3C1F1F] text-white fixed top-0 left-0 flex flex-col z-[60]">
      {/* Sidebar Logo */}
    <Link to="/home">
         
    <div className="flex justify-center items-center p-4 mb-4 cursor-pointer">
      <img
        src={logo}
        alt="Company Logo"
        className="w-[150px] h-[50px]"
      />
    </div>
    </Link>
 
 
      {/* Sidebar Links */}
      <div className="flex-1 overflow-y-auto sidebar-scroll">
        {sidebarLinks.map(({ label, route }) => (
          <Link
            key={label}
            to={route}
            className={`p-3 cursor-pointer flex items-center justify-start text-xs transition-all duration-300 ease-in-out ${
              location.pathname === route
                ? "bg-[#998923] rounded-lg"
                : "hover:bg-gray-700 hover:border-l-4 hover:border-[#998923] hover:rounded-lg"
            }`}
          >
            {label}
            {label === "Orders" && (
              <span className="ml-2 px-2 py-0.5 rounded-full bg-red-100 text-red-700 text-xs font-semibold">
                {ordersCount}
              </span>
            )}
 
            {label === "Prescription List" && (
              <span className="ml-2 px-2 py-0.5 rounded-full bg-red-100 text-red-700 text-xs font-semibold">
                {prescriptionCount || ""}
              </span>
            )}
          </Link>
        ))}
      </div>
 
      {/* Logout Button */}
      <div
        className={`p-2 cursor-pointer flex items-center justify-start text-xs mt-auto mb-2 transition-all duration-300 ease-in-out ${activeItem === "Logout"
          ? "bg-red-500 rounded-lg"
          : "hover:bg-red-600 hover:border-l-4 hover:border-red-500 hover:rounded-lg"
          }`}
        onClick={() => handleItemClick("Logout")}
      >
        Logout
      </div>
    </div>
  );
};
 
export default AdminSideBar;